module.exports = __webpack_public_path__ + "img/CQ(2).b1cf0dae.webp";